module.exports = __webpack_public_path__ + "img/case-logo-23.66e7adc6.png";